export default __webpack_public_path__ + "static/media/EMprint Regular.d483cd6f.woff";